module.exports = __webpack_public_path__ + "static/media/fishman.2c76ac80.png";